import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MEMBER: AppRouteRecordRaw = {
  path: '/member',
  name: 'member',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.member',
    icon: 'icon-user-group',
    requiresAuth: true,
    order: 8,
  },
  children: [
    {
      path: 'stored',
      name: 'stored',
      component: () => import('@/views/member/stored/index.vue'),
      meta: {
        locale: 'menu.member.stored',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'trans',
      name: 'trans',
      component: () => import('@/views/member/trans/index.vue'),
      meta: {
        locale: 'menu.member.trans',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'fleet',
      name: 'fleet',
      component: () => import('@/views/member/fleet/index.vue'),
      meta: {
        locale: 'menu.member.fleet',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default MEMBER;
